import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WdxBadgeModule } from '@wdx/shared/components/wdx-badge';
import {
    WdxButtonModule,
    WdxButtonSize,
    WdxButtonStyle,
} from '@wdx/shared/components/wdx-button';
import { WdxStopPropagationDirective } from '@wdx/shared/components/wdx-stop-propagation';
import { TranslateTokenisedStringPipe, WdxThemeColor } from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export type BadgeRendererMapping = Record<string, WdxThemeColor>;

export interface BadgeRendererValue {
    disableBadge?: boolean;
    untranslatedLabel?: string;
    label: string;
    mapping: BadgeRendererMapping;
    preLabel?: string;
    preLabelUrl?: string[];
    preLabelClickCallback?: () => void;
    postLabel?: string;
    postLabelUrl?: string[];
    postLabelClickCallback?: () => void;
}

@Component({
    selector: 'wdx-ag-grid-badge-cell-renderer',
    imports: [
        CommonModule,
        RouterModule,
        WdxBadgeModule,
        WdxButtonModule,
        WdxStopPropagationDirective,
        TranslateTokenisedStringPipe,
    ],
    templateUrl: './badge-cell-renderer.component.html',
    styleUrls: ['./badge-cell-renderer.component.scss'],
    host: { class: 'd-flex h-100 align-items-center justify-content-between' },
})
export class BadgeRendererComponent implements ICellRendererAngularComp {
    public readonly WdxButtonStyle = WdxButtonStyle;
    public readonly WdxButtonSize = WdxButtonSize;
    public label?: string;
    public postLabel?: string;
    public postLabelUrl?: string[];
    public preLabelUrl?: string[];
    public preLabel?: string;
    public disableBadge = false;
    public badgeClasses = 'badge';
    public preLabelClickCallback?: () => void;
    public postLabelClickCallback?: () => void;
    private mapping?: BadgeRendererMapping;

    public agInit(params: ICellRendererParams<any, BadgeRendererValue>): void {
        if (params?.value) {
            this.label = params.value.label;
            this.preLabel = params.value?.preLabel;
            this.preLabelUrl = params.value?.preLabelUrl;
            this.postLabel = params.value?.postLabel;
            this.postLabelUrl = params.value?.postLabelUrl;
            this.mapping = params.value?.mapping;
            this.disableBadge = Boolean(params.value?.disableBadge);
            this.preLabelClickCallback = params.value?.preLabelClickCallback;
            this.postLabelClickCallback = params.value?.postLabelClickCallback;
            if (!this.disableBadge) {
                this.setBadgeClasses(
                    params.value?.untranslatedLabel ?? this.label,
                );
            }
        }
    }

    public refresh(
        params: ICellRendererParams<any, BadgeRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }

    private setBadgeClasses(label?: string) {
        const colorClass =
            (label &&
                this.mapping &&
                this.mapping[label.toString().toLowerCase()]) ||
            '';
        this.badgeClasses = colorClass ? `badge badge-${colorClass}` : 'badge';
    }
}
